// import React from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   CartesianGrid,
//   Legend,
// } from "recharts";
// import {
//   SummaryPeriod,
//   useFetchStatusTrend,
// } from "../../../apis/dashboardApis";

// type StatusTrendChartProps = {
//   summaryType?: SummaryPeriod;
//   startDate?: string;
//   endDate?: string;
// };

// const formatDay = (day: string) => {
//   const date = new Date(day);
//   if (Number.isNaN(date.getTime())) return day;

//   return date.toLocaleDateString("en-US", {
//     month: "short",
//     day: "numeric",
//   });
// };

// const StatusTrendChart: React.FC<StatusTrendChartProps> = ({
//   summaryType,
//   startDate,
//   endDate,
// }) => {
//   const { data: statusTrendData } = useFetchStatusTrend({
//     type: summaryType ?? "Today",
//     startDate,
//     endDate,
//   });

//   const data =
//     statusTrendData?.map((item) => ({
//       ...item,
//       dayLabel: formatDay(item.day),
//     })) ?? [];

//   return (
//     <div className="w-full rounded-3xl bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] py-7 px-6">
//       {/* Header */}
//       <div className="mb-6 flex items-center justify-between">
//         <h2 className="text-lg font-semibold   text-[#212121]">
//           Status Trend
//         </h2>
//       </div>

//       {/* Chart */}
//       <div className="h-[260px] w-full">
//         <ResponsiveContainer width="100%" height="100%">
//           <LineChart
//             data={data}
//             margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
//           >
//             <CartesianGrid stroke="#D2D2D2" vertical={true} horizontal={true} />

//             <XAxis
//               dataKey="dayLabel"
//               tick={{ fill: "#7E8CA6", fontSize: 14 }}
//               axisLine={false}
//               tickLine={false}
//             />

//             <YAxis
//               tick={{ fill: "#7E8CA6", fontSize: 14 }}
//               axisLine={false}
//               tickLine={false}
//             />

//             <Tooltip
//               labelFormatter={(_, payload) => payload?.[0]?.payload?.day ?? ""}
//               contentStyle={{
//                 backgroundColor: "#FFFFFD",
//                 borderRadius: "12px",
//                 color: "#212121",
//               }}
//             />

//             <Legend
//               verticalAlign="top"
//               height={40}
//               iconType="plainline"
//               wrapperStyle={{
//                 color: "#fff",
//                 fontSize: "14px",
//               }}
//             />

//             {/* Delivered */}
//             <Line
//               type="monotone"
//               dataKey="delivered"
//               name="Delivered"
//               stroke="#22C55E"
//               strokeWidth={3}
//               dot={{
//                 r: 4,
//                 strokeWidth: 2,
//                 fill: "#121B2E",
//               }}
//               activeDot={{ r: 6 }}
//             />

//             {/* Not Delivered */}
//             <Line
//               type="monotone"
//               dataKey="notDelivered"
//               name="Not Delivered"
//               stroke="#EF4444"
//               strokeWidth={3}
//               dot={{
//                 r: 4,
//                 strokeWidth: 2,
//                 fill: "#121B2E",
//               }}
//               activeDot={{ r: 6 }}
//             />

//             {/* OFD */}
//             <Line
//               type="monotone"
//               dataKey="ofd"
//               name="OFD"
//               stroke="#F59E0B"
//               strokeWidth={3}
//               dot={{
//                 r: 4,
//                 strokeWidth: 2,
//                 fill: "#121B2E",
//               }}
//               activeDot={{ r: 6 }}
//             />
//           </LineChart>
//         </ResponsiveContainer>
//       </div>
//     </div>
//   );
// };

// export default StatusTrendChart;

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

import {
  SummaryPeriod,
  useFetchStatusTrend,
} from "../../../apis/dashboardApis";

type StatusTrendChartProps = {
  summaryType?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
};

const formatDay = (day: string) => {
  const date = new Date(day);

  if (Number.isNaN(date.getTime())) return day;

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

const StatusTrendChart: React.FC<StatusTrendChartProps> = ({
  summaryType,
  startDate,
  endDate,
}) => {
  const { data: statusTrendData } = useFetchStatusTrend({
    type: summaryType ?? "Today",
    startDate,
    endDate,
  });

  const data =
    statusTrendData?.map((item) => ({
      ...item,
      dayLabel: formatDay(item.day),
    })) ?? [];

  return (
    <div className="h-full rounded-[28px] border border-[#ECECEC] bg-white p-6 shadow-sm">
      {/* Header */}
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-[#111827]">Status Trend</h2>
        </div>
      </div>

      {/* Chart */}
      <div className="h-[330px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0,
            }}
          >
            <CartesianGrid stroke="#F1F5F9" vertical={false} />

            <XAxis
              dataKey="dayLabel"
              tick={{
                fill: "#94A3B8",
                fontSize: 12,
              }}
              axisLine={false}
              tickLine={false}
            />

            <YAxis
              tick={{
                fill: "#94A3B8",
                fontSize: 12,
              }}
              axisLine={false}
              tickLine={false}
            />

            <Tooltip
              contentStyle={{
                background: "#FFFFFF",
                border: "1px solid #E5E7EB",
                borderRadius: "16px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              }}
            />

            <Legend
              verticalAlign="top"
              align="right"
              iconType="circle"
              wrapperStyle={{
                paddingBottom: "20px",
                fontSize: "14px",
              }}
            />

            {/* Delivered */}
            <Line
              type="monotone"
              dataKey="delivered"
              name="Delivered"
              stroke="#22C55E"
              strokeWidth={4}
              dot={{
                r: 0,
              }}
              activeDot={{
                r: 7,
                strokeWidth: 0,
              }}
            />

            {/* Not Delivered */}
            <Line
              type="monotone"
              dataKey="notDelivered"
              name="Not Delivered"
              stroke="#EF4444"
              strokeWidth={4}
              dot={{
                r: 0,
              }}
              activeDot={{
                r: 7,
                strokeWidth: 0,
              }}
            />

            {/* OFD */}
            <Line
              type="monotone"
              dataKey="ofd"
              name="OFD"
              stroke="#F59E0B"
              strokeWidth={4}
              dot={{
                r: 0,
              }}
              activeDot={{
                r: 7,
                strokeWidth: 0,
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default StatusTrendChart;
